export const fakeTableData = {
  device: [
    { SKU: "", UID: "", company: "", location: "", employee: "", version: "" },
  ],
  employee: [{ name: "", company: "", location: "", group: "", device: "" }],
  location: [{ name: "", UID: "", company: "" }],
  manager: [{ name: "", email: "", company: "", location: "" }],
}
